<template>
  <!-- 最外层包含展开收起的部分 -->
  <div :class="[{ 'recom-list': recomNotAddPriceBuyLen === 0 && showTitle }]">
    <div
      v-if="showTitle"
      :class="
        recomNotAddPriceBuyLen > 0
          ? 'course-list-title'
          : 'course-list-title-add-price-buy'
      "
    ></div>
    <div :id="`${cardType}-course-card-list`" class="course-tab-list">
      <!-- 此处遍历的为cnt_list / recom_list -->
      <course-tab
        v-for="(tabItem, tabIndex) in commonCourseTabList"
        :key="tabKey(tabIndex, tabItem)"
        :info="tabItem"
        :tab_list_index="tabIndex"
        :isLastTab="tabIndex === commonCourseTabList.length - 1"
        :recomNotAddPriceBuyLen="recomNotAddPriceBuyLen"
      />
    </div>

    <!-- 收起展开-->
    <div
      v-if="showExpand"
      :class="['common-status', { 'collapse-status': !isFold }]"
      @click="isFold = !isFold"
    >
      {{ isFold ? "展开全部" : "收起" }}
      <img alt="arrow" src="@/assets/img/Home/login-icon.png" />
    </div>
  </div>
</template>

<script>
import courseTab from "./courseTab.vue";
export default {
  provide() {
    return {
      cardType: this.cardType, // 区分当前是推荐课程还是原班课程
      recomNotAddPriceBuyLen: this.recomNotAddPriceBuyLen, // 非加价购推荐课程数量
    };
  },
  props: {
    cardType: {
      type: String,
      default: "",
    },
    courseTabList: {
      type: Array,
      default: () => [],
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    // 是否展示展开收起模块
    showExpand: {
      type: Boolean,
      default: false,
    },
    isAddPriceBuy: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    commonCourseTabList() {
      console.log("触发commonCourseTabList更新");
      if (this.showExpand) {
        if (this.isFold) {
          // 若为折叠状态
          return this.courseTabList.filter(
            (item) => item.isEmptyCourseCard === false
          );
        } else {
          return this.courseTabList;
        }
      }
      return this.courseTabList;
    },
    tabKey() {
      return function (tabIndex, tabItem) {
        const { product_id, product_type } = tabItem?.package_info?.[0] || {};
        return `${tabIndex}_${product_id}_${product_type}`;
      };
    },
    // 是否配置扩科文件
    recomNotAddPriceBuyLen() {
      return this.courseTabList.filter((item) => !item.isAddPriceBuy).length;
    },
  },
  components: {
    courseTab,
  },
  data() {
    return {
      isFold: true, // 是否折叠状态
    };
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.recom-list {
  padding-top: 12px;
  margin-top: 8px;
  border-radius: 16px;
  background: #fff;
}
.course-list-title {
  margin-top: 24px;
  margin-bottom: 4px;
  background: url("https://editor.xesimg.com/tailor/resource/%E6%8E%A8%E8%8D%90%E5%A5%BD%E8%AF%BE%E6%A0%87%E9%A2%981-1715395018644.png")
    no-repeat;
  width: 351px;
  height: 32px;
  background-size: 100% 100%;
}
.course-list-title-add-price-buy {
  background: url("https://editor.xesimg.com/tailor/resource/reom-title-1761043191799.png")
    no-repeat;
  width: 110px;
  height: 24px;
  margin: 0 0 8px 12px;
  background-size: 100% 100%;
}
.common-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #fff;
  border-radius: 45px;
  margin-top: 8px;
  color: #666;
  font-family: "PingFang SC";
  font-size: 13px;
  font-weight: 400;
  height: 44px;

  img {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    transform: rotate(90deg);
  }
}
.collapse-status {
  img {
    transform: rotate(-90deg);
  }
}
.course-tab-list {
  overflow: hidden;
}
</style>
